// libs
import React from 'react';

// components
import { Stack, Typography } from '@lyearn/ui';

import getExerciseIcon from '../../../exercise/helpers/getExerciseIcon';
// types
import { ExerciseOption } from './types';

export const renderOption = (option: ExerciseOption) => {
  const Image = getExerciseIcon({ exercise: option.exercise, size: 24 });

  return (
    <Stack alignItems="center" gapX={12}>
      {Image}
      <Typography className="flex-shrink-0" color="text-text-secondary" variant="body-short-01">
        {option.title}
      </Typography>
    </Stack>
  );
};
